import { Stack } from '@mui/material';
import { Fragment } from 'react';
import { TermContentText } from '../../TermsModal/styles';

export const FullNonTerm = () => {
  return (
    <Fragment>
      <TermContentText>
        1. During the Term of this Agreement and for a period of six (6) months
        from the termination of this Agreement, neither the Client nor any
        person connected with the Client (including but not limited to immediate
        family members of the Client) shall in any function or capacity, whether
        for his or her own account or for the account of any other person or
        entity (other than the Company), directly or indirectly, solicit the
        services of the Sitter or services similar to that provided by the
        Sitter under this Agreement (inclusive of the Trial(s)). As used in this
        Agreement, “solicit” means the initiation, whether directly or
        indirectly, of any contact or communication of any kind whatsoever, for
        the express or implicit purpose of inviting, encouraging or requesting a
        Sitter to:
        <Stack mt={1} ml={2} spacing={1}>
          <TermContentText>
            a. engage in any capacity whatsoever for the provision of the
            Service and other functions or responsibilities incidental or
            closely connected to it directly to the Client or any other person;
          </TermContentText>
          <TermContentText>
            b. provide babysitting services outside the scope of this Agreement
            to any other person;
          </TermContentText>
          <TermContentText>
            c. otherwise discontinue, change or reduce the Sitter’s existing
            independent contractor relationship with the Company.
          </TermContentText>
        </Stack>
      </TermContentText>
      <TermContentText>
        2. In the event of default of Clause 1 by the Client, the Client shall
        be liable to indemnify the Company to a sum of S$2,000.00. In addition,
        notwithstanding clause 7.2 above, the Company may at its sole discretion
        terminate this Agreement with immediate effect.
      </TermContentText>
      <TermContentText>
        3. The Client agrees that the scope of prohibitions set out in Clause 1
        to 10.2 are reasonable and necessary to protect the Company. If any
        court or other tribunal having jurisdiction to determine the validity,
        scope or enforceability of this Clause 10, determines that, if strictly
        applied any provision hereof would be invalid or unenforceable, the
        relevant scope of restrictions and/or the time restrictions set forth in
        Clause 10.1 to 10.2 hereof shall be modified to the extent necessary to
        make such restrictions, as modified, valid and enforceable to the
        fullest extent permitted by law
      </TermContentText>
      <TermContentText>
        4. Aunty App and Aunty Concierge services provided by Aunty are distinct
        and separate services. Clients engaging in Aunty Concierge services will
        be subject to terms and conditions unique to that service. Sitters
        assigned to clients through the Concierge service will be exclusive to
        that placement for a duration of three (3) months. During this
        exclusivity period, the assigned sitter cannot be engaged via the Aunty
        App or any other form of direct or indirect engagement outside the
        Concierge service. Any attempt to engage the assigned sitter outside the
        Concierge service within the specified three (3) month period will be
        considered a breach of contract. 
      </TermContentText>
    </Fragment>
  );
};

export default FullNonTerm;
